/* */ 
"use strict";
var di_1 = require('./di');
exports.PLATFORM_DIRECTIVES = new di_1.OpaqueToken("Platform Directives");
exports.PLATFORM_PIPES = new di_1.OpaqueToken("Platform Pipes");
